import React, { Fragment } from "react";
import Head from "next/head";

const GeneralShopMeta = ({ shop }) => {
  const description = shop?.elements
    ?.filter((e) => e.element_type === "Text")
    .map((e) => e.long_description || "")
    .join("\n\n");

  return (
    <Head>
      <title>{shop?.title ? `${shop.title} | Powered by Carte` : "Carte Shop"}</title>
      <meta
        name="description"
        content={description || "All you need to launch your business online. No coding required."}
      />
      <link
        rel="canonical"
        href={
          typeof window !== "undefined"
            ? `${window.location.origin}/`
            : `https://${shop?.subdomain ? shop.subdomain + "." : ""}carteapp.io/`
        }
      />
      <meta
        property="og:type"
        content={shop?.title ? `${shop.title} | Powered by Carte` : "Carte Shop"}
        key="ogtype"
      />
      <meta
        property="og:site_name"
        content={shop?.title ? `${shop.title} | Powered by Carte` : "Carte Shop"}
        key="ogsitename"
      />
      <meta
        property="og:url"
        content={
          typeof window !== "undefined"
            ? `${window.location.origin}/`
            : `https://${shop?.subdomain ? shop.subdomain + "." : ""}carteapp.io/`
        }
        key="ogurl"
      />
      <meta
        property="og:title"
        content={shop?.title ? `${shop.title} | Powered by Carte` : "Carte Shop"}
        key="ogtitle"
      />
      <meta
        property="og:description"
        content={description || "All you need to launch your business online. No coding required."}
        key="ogdesc"
      />
      <meta
        property="og:image"
        content={
          shop?.logo ||
          shop?.vendor?.company_photo ||
          "https://carte-assets.carteapp.io/fettuccine/logov2.png"
        }
        key="ogimage"
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content={shop?.title ? `${shop.title} | Powered by Carte` : "Carte Shop"}
      />
      <meta
        name="twitter:description"
        content={description || "All you need to launch your business online. No coding required."}
      />
      <meta
        name="twitter:image"
        content={
          shop?.logo ||
          shop?.vendor?.company_photo ||
          "https://carte-assets.carteapp.io/fettuccine/logov2.png"
        }
      />
      <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="robots" content="index, follow" />
      {shop?.meta_tag_is_active && (
        <Fragment>
          {/* <meta name={"facebook-domain-verification"} content={shop.meta_tag_content} /> */}
          <script>
            {`!function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '${shop?.meta_pixel_id}');
                fbq('track', 'PageView');`}
          </script>
          <noscript>
            <img
              alt="Facebook Pixel"
              height="1"
              width="1"
              style={{ display: "none" }}
              src={`https://www.facebook.com/tr?id=${shop?.meta_pixel_id}&ev=PageView&noscript=1`}
            />
          </noscript>
        </Fragment>
      )}
    </Head>
  );
};

export default GeneralShopMeta;
